import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

const getListLevelWilayah = async () => {
  const response = await api.get("/master/level-wilayah/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterLevelWilayahPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listLevelWilayah"],
    queryFn: getListLevelWilayah,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
